import { User } from 'types/user';

const isUserTrialManager = (user: User) => Boolean(user && user.isTrialManager);

export default isUserTrialManager;
